import { Image } from "./image";
import React from "react";
import { motion } from "framer-motion";

export const Gallery = (props) => {
  return (
    <motion.div
      id="gallery"
      className="text-center"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.4 }}
    >
      <div className="container">
        <div className="section-header-modern text-center">
          <span className="section-tag"><i className="fa fa-camera"></i> Operations Gallery</span>
          <h2>How We Operate</h2>
          <p>
            Our operations in action - from cargo handling and container loading to freight coordination and global logistics management.
          </p>
        </div>
        <div className="gallery-items">
            {props.data
              ? props.data.map((d, i) => (
                  <motion.div
                    key={`${d.title}-${i}`}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-50px" }}
                    transition={{ duration: 0.3, delay: i * 0.05 }}
                  >
                    <Image
                      title={d.title}
                      smallImage={d.smallImage}
                    />
                  </motion.div>
                ))
              : "Loading..."}
          </div>
      </div>
    </motion.div>
  );
};
